// extracted by mini-css-extract-plugin
export default {"editor":"JoditWysiwyg_editor__wJe3q","hasError":"JoditWysiwyg_hasError__kF0uF","disabled":"JoditWysiwyg_disabled__z4aIZ"};